import { Component } from '@angular/core';
import {PageContainerComponent, RightContainerComponent} from "@components";

@Component({
  selector: 'wun-about-us',
  imports: [
    PageContainerComponent,
    RightContainerComponent
  ],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {

}
